<div class="container-fluid" *ngIf="global_loader">
  <div class="mountroot">
    <div class="loader-container">
      <div class="spinner-spinner">

      </div>
    </div>
  </div>
</div>
<div [@fadeimagesInOut]>
    <div [ngClass]="{'global-loader2':global_loader}" *ngIf="!global_loader">
        <div class="min-height " style="background-color: #fff;">
            <div class="ab-container-full bg-white" *ngIf="!global_loader">
                <div class="ab-container p-16 d-md-block d-sm-block d-none">
                    <div class="w-block wt-block">
                        <div class="row">
                            <div class="breadcrum-container">
                                <nav class="d-flex justify-content-between" aria-label="breadcrumb">
                                    <ol class="breadcrumb-list pl-0">
                                        <li class="breadcrumb-item " aria-current="page" routerLink="">Home</li>
                                        <li class="breadcrumb-item active" aria-current="page">Brands & Manufacturers
                                        </li>
                                    </ol>
                                    <button title="Back" class="back-btn" style="width: fit-content;" (click)="_location.back()"> <i
                                            class="fa fa-angle-left "></i> Back</button>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!---------loader------->
            <ng-container *ngIf="global_loader">
                <div class="w-block wt-block is-loading">
                   <div class="ab-container-full bg-white breadcrumb m-0"></div>
                </div>
            </ng-container>
            <!------END loader------->
            <div style="min-height: 100vh;">
                <div class="m-block top-strip-for-mob-back">
                    <div routerLink="">
                        <a aria-current="page"> <img
                                src="https://res.cloudinary.com/afterbricks/image/upload/v1682438470/icons/back_g6vjro.png"
                                alt="back to product"></a>
                        <p>Home</p>
                    </div>
                    <div style="font-family: 'SF UI Text Semibold';padding-right: 16px;">
                        Brands and manufacturers
                    </div>
                </div>

                <div class="ab-container py-0 bg-image " >
                    <div class="banner-container" *ngIf="!global_loader">
                        <img alt="Explore a diverse array of top, trending & promising interior products brands." src="https://res.cloudinary.com/afterbricks/image/upload/v1710240363/Brands_d2uyny.webp">
                    <div class="brand-banner-heading-li">
                    </div>
                    </div>
                    <div class="banner-container-loader" *ngIf="global_loader">
                    </div>
                </div>
               <div class=" ab-container">
                <div class="bg-m-white mb-md-0 sec-p-3  tab-pad-16 sec-pad-gap" *ngIf="!global_loader">
                    <h4 class="h-font4">Select a department</h4>
                    <ul class="chip-ul">
                        <li class="chip-li" *ngIf="main_category_list.length > 1">
                            <a class="chip-card " (click)="onDepartment(undefined,true)"
                                [ngClass]="{'active-chip-manu':activeDpId===undefined}" title="All">All</a>
                        </li>
                        <li class="chip-li" *ngFor="let dp of main_category_list;let dpi=index">
                            <a class="chip-card" [ngClass]="{'active-chip-manu':activeDpId===dp.id}" [title]="dp?.name"
                                (click)="onDepartment(dp.id,true)">
                                {{dp?.name}}</a>
                        </li>
                    </ul>
                </div>
                <!--------loader----------------->
                <div class="bg-m-white  mb-md-0 sec-p-3  tab-pad-16 is-loading" *ngIf="global_loader">
                    <h4 class="h-font4 m-block name"></h4>
                    <ul class="chip-ul name chip-loader"></ul>
                </div>
                <!--------END loader----------------->
               </div>
                <div class=" p-0  tab-pad" style="background-color:  #ece6df;">
                 
                    <div class="ab-container ab-bg-m-grey-1 ab-m-p-0 ab-br-2 ab-p-2 mb-5 p-16" [@fadeimagesInOut]  *ngIf="!global_loader" [ngClass]="{'p-readonly':is_brand_loading}" >
                        <div class="numbers-of-products">
                            <p *ngIf="brand_list?.length">Total brands:<span>{{brand_list.length}}</span></p>
                        </div>
                        <ul class="brand-logo-card">
                            <li *ngFor="let brand of brand_list;">
                                <a (click)="branddetails(brand)" style="position: relative;" [title]="brand?.brand">
                                    <div class="brand-img">
                                        <img *ngIf="brand?.logo" [src]="brand?.logo" [alt]="brand?.brand">
                                    </div>
                                    <div class="cashback-chip" *ngIf="brand.cashback">
                                        <p> Cashback </p>
                                        <!-- {{brand?.cashback?.cashback}}% -->
                                    </div>
                                </a>
                            </li>
                        </ul>
                        <div class="new-loader-section" *ngIf="!global_loader && is_brand_loading">
                            <span class="new-loader"></span>
                        </div>
                    </div>
                    <!----------loader---------------->
                        <!-- <div class="numbers-of-products">
                            <p class="name"></p>
                        </div> -->
                       
                        <!-- <ul class="brand-logo-card is-loading">
                            <li *ngFor="let brand of [1,2,3,4,5,6,7,8,1,2,3,4,5,6,7,8,1,2,3,4,5]">
                                <a>
                                    <div class="brand-img">
                                    </div>
                                </a>
                            </li>
                        </ul> -->
                  
                    <!----------END loader---------------->
                </div>
            </div>
        </div>
        <div class="basic-info-popup" *ngIf="!_as?.isOnMobilePlatform && ctatype_list?.length">
            <p-dialog [(visible)]="showCatTypePopUp" [modal]="true" [showHeader]="false" [baseZIndex]="10000"
                [transitionOptions]="_pop.dialogTransitionTime">
                <div class="close-popup" (click)="showCatTypePopUp=false">
                    <img alt= "close icon"
                        src="https://res.cloudinary.com/afterbricks/image/upload/v1643650270/icons/close_nqzrnn.svg">
                </div>
                <div class="ab-modal-heading">
                    <h3>Select by Sub Category</h3>
                    <p>Click below and continue </p>
                </div>
                <div>
                    <ul class="ab-modal-body-ul">
                        <li *ngFor="let ctatype of ctatype_list;let ctatypei=index">
                            <a class="ab-modal-body-card" [title]="ctatype?.name" (click)=" onCategoryType(ctatype)">
                                <div class="ab-modal-body-img">
                                    <img *ngIf="ctatype?.icon" [src]="ctatype?.icon" [alt]="ctatype?.name">
                                </div>
                                <div class="ab-modal-dept-name">
                                    <p>{{ctatype?.name}}</p>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </p-dialog>
        </div>
        <div class="basic-info-popup" *ngIf="_as?.isOnMobilePlatform && ctatype_list?.length">
            <p-sidebar [(visible)]="showCatTypeMobPopUp" position="bottom" [baseZIndex]="10000">
                <div class="close-popup" (click)="showCatTypeMobPopUp=false">
                    <img alt=""
                        src="https://res.cloudinary.com/afterbricks/image/upload/v1643650270/icons/close_nqzrnn.svg">
                </div>
                <div class="ab-modal-heading">
                    <h3>Select by Category</h3>
                    <p>Click below and continue </p>
                </div>
                <ul class="ab-modal-body-ul">
                    <li *ngFor="let ctatype of ctatype_list;let ctatypei=index">
                        <a class="ab-modal-body-card" [title]="ctatype?.name" (click)=" onCategoryType(ctatype)">
                            <div class="ab-modal-body-img">
                                <img *ngIf="ctatype?.icon" [src]="ctatype?.icon" [alt]="ctatype?.name">
                            </div>

                            <div class="ab-modal-dept-name">
                                <p>{{ctatype?.name}}</p>
                            </div>
                        </a>
                    </li>
                </ul>
            </p-sidebar>
        </div>
        <app-footer></app-footer>
    </div>
</div>